import VideoJsPlayer from 'video.js/dist/types/player';
import { RewindVideo } from './rewindStitcher.types';

export const playRewindAtPosition = ({
  player,
  rewind,
  positionSeconds,
  forcePlay = false,
}: {
  player: VideoJsPlayer;
  rewind: RewindVideo;
  positionSeconds: number;
  forcePlay?: boolean;
}) => {
  const playerPlaybackSpeed = player.playbackRate();

  // @ts-ignore the type definitions for videojs are incorrect
  if (rewind.url !== player.currentSource().src) {
    player.src({
      src: rewind.url,
      type: 'video/mp4',
    });
  }

  const playing = !player.paused();

  player.ready(async () => {
    player.currentTime(positionSeconds);
    // Make sure when we load the new src we persist the users playback rate
    player.playbackRate(playerPlaybackSpeed || 1);
    // if the player is paused, don't play it
    if (playing || forcePlay) {
      await player.play();
    }
  });

  return player;
};

export const attemptToPlayNextRewind = ({
  player,
  rewindList,
  currentRewind,
  setCurrentRewind,
}: {
  player: VideoJsPlayer;
  rewindList: RewindVideo[];
  currentRewind: RewindVideo | null;
  setCurrentRewind: (rewind: RewindVideo) => void;
}) => {
  const currentClipIndex = rewindList.findIndex((clip) => clip.url === currentRewind?.url);
  const nextClipIndex = currentClipIndex + 1;

  if (nextClipIndex < rewindList.length) {
    const nextClip = rewindList[nextClipIndex];
    setCurrentRewind(nextClip);
    playRewindAtPosition({
      player,
      rewind: nextClip,
      positionSeconds: 0,
      forcePlay: true,
    });
  } else {
    player.trigger('rewindStitcher:rewindListEnded');
    player.pause();
  }
};
